// hooks/useLearnerTrainings.js
import { getNameList } from "PlatForms/OrgLMS/Services/LearnerService/trainingService";
import { getLearnerTrainings } from "PlatForms/OrgLMS/Services/LearnerService/trainingService";
import { toArray } from "Common/utils/list";
import { useEffect, useState } from "react";

const useLearnerTrainings = (learnerUserId, token, completed = false) => {
  const [trainingData, setTrainingData] = useState([]);
  const [nameList, setNameListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        const data = await getLearnerTrainings(learnerUserId, token, completed);
        setTrainingData(toArray(data));
      } catch (error) {
        console.error("Fetching error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (learnerUserId && token) fetchTrainings();
  }, [learnerUserId, token, completed]);

  useEffect(() => {
    const fetchNameList = async () => {
      try {
        const data = await getNameList(learnerUserId, token);
        setNameListData(toArray(data));
      } catch (error) {
        console.error("Fetching error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (learnerUserId && token) fetchNameList();
  }, [learnerUserId, token]);

  return { trainingData, loading, nameList };
};

export default useLearnerTrainings;
